import React from 'react';
import { Dimensions, Platform, View } from 'react-native'

import PropTypes from 'prop-types';

import { VFText, VFButton, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';
import { Types } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import styles from './SuccessModal.styles';

const SuccessModal = ({
  isVisible,
  title,
  modalType,
  toggleModal,
  withCloseButton,
  lottieType,
  message,
  description,
  buttonText,
  onButtonPress,
  theme
}) => {
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <Modal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={() => toggleModal()}
        onBackdropPress={() => toggleModal()}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '600px',
            maxWidth: '600px',
            height: 'auto',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '50px',
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <VFLottieView
            autoPlay
            containerStyle={styles.modalIconContainer}
            loop={false}
            lottieViewStyle={styles.iconContainer}
            type={lottieType}
          />
          <VFText i18nKey={message} style={styles.modalMessage} />
          <VFText i18nKey={description} style={styles.modalDescription} />
          <VFButton
            title={buttonText}
            onPress={onButtonPress}
            style={styles.modalButton}
            textStyle={styles.modalButtonText}
          />
        </View>
      </Modal>
    )
  }
  return (
    <QuickActionMenu
      isVisible={isVisible}
      title={title}
      type={modalType}
      toggleModal={toggleModal}
      containerStyle={styles.modalContent}
      headerStyle={styles.modalHeader}
      withCloseButton={withCloseButton}
    >
      <VFLottieView
        autoPlay
        containerStyle={styles.modalIconContainer}
        loop={false}
        lottieViewStyle={styles.iconContainer}
        type={lottieType}
      />
      <VFText i18nKey={message} style={styles.modalMessage} />
      <VFText i18nKey={description} style={styles.modalDescription} />
      <VFButton
        title={buttonText}
        onPress={onButtonPress}
        style={styles.modalButton}
        textStyle={styles.modalButtonText}
      />
    </QuickActionMenu>
  );
};

SuccessModal.propTypes = {
  isVisible: PropTypes.bool,
  title: PropTypes.string,
  modalType: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  toggleModal: PropTypes.func,
  withCloseButton: PropTypes.bool,
  lottieType: PropTypes.string,
  message: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonPress: PropTypes.func,
};

export default SuccessModal;
